import React, { useEffect, useState } from "react";
import s from "./echo-button.module.scss";

const EchoButton = (props) => {

    const [title, setTitle] = useState(props.title);
    const [isDisabled, setIsDisabled] = useState(props.disabled);

    useEffect(() => {
        setTitle(props.title);
        setIsDisabled(props.disabled);
    }, [props])

    const ButtonIcon = props.icon ? props.icon : null;
    const styles = props.styles;
    const textStyles = props.textStyles;

    const clickedButton = () => {
        props.callback && props.callback()
    }

    return (
        
        <button disabled={isDisabled} className={s.EchoButton} style={styles} onClick={clickedButton}>
            <span style={textStyles}>
                {title}
                {ButtonIcon ? <ButtonIcon /> : null }
            </span>
        </button>
    )
}

export default EchoButton;